import React, { useContext } from 'react';
import { SiteConfigContext } from '../SiteConfigProvider';
export function AuthorByline(_ref) {
  var type = _ref.type;

  var _useContext = useContext(SiteConfigContext),
      META_DATA = _useContext.siteConstants.META_DATA;

  var siteName = META_DATA.applicationName;

  var getAuthorByline = function getAuthorByline(type) {
    switch (type) {
      case 'Contributing Writer':
        return /*#__PURE__*/React.createElement(React.Fragment, null, siteName, " Contributing Writer");

      case 'Old BDC Member':
      case 'New BDC Member':
        return /*#__PURE__*/React.createElement(React.Fragment, null, "business.com Member");

      case 'Staff':
        return /*#__PURE__*/React.createElement(React.Fragment, null, siteName, " Staff");

      case 'Sponsor':
      default:
        return null;
    }
  };

  return getAuthorByline(type);
}